import { setConsent } from 'firebase/analytics';
import { getUserCookiesConsent } from '~/utils/local-storage-utils/local-storage-utils';
import { applyClarityConsent } from './clarity-consent';

export const applyAnalyticsConsent = (granted: boolean) => {
  const value = granted ? 'granted' : 'denied';
  setConsent({
    analytics_storage: value,
    personalization_storage: value,
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    functionality_storage: 'granted',
    security_storage: 'granted',
  });
};

/**
 * For returning users who already interacted with the consent banner,
 * apply their stored preference synchronously before any analytics
 * provider initializes.
 *
 * First-time visitors are handled by useCookieConsentMode (hook) once
 * Remote Config resolves the cookie_consent_enabled flag.
 *
 * All provider consent calls are gated here so they stay in one place.
 */
export const applyStoredConsent = () => {
  const storedConsent = getUserCookiesConsent();
  if (!storedConsent) {
    return;
  }
  applyAnalyticsConsent(storedConsent.acceptedCookies);
  applyClarityConsent(storedConsent.acceptedCookies);
};
